module.exports = __webpack_public_path__ + "73aabe837a913a5fa52541a2bb4d5875.svg";